import { memo, useMemo } from "react";
import { bool, number, object, string } from "prop-types";
import { BreakdownTableDepths } from "@repo/utils";
import Grid from "@material-ui/core/Grid";
import useStyle from "./Row/Row.style";
import classnames from "classnames";
import { DragHandleCell, PlaceholderCell } from "@tools";

export const PlaceholderRow = memo(({
  isFirstGroupRow,
  isLastGroupRow,
  style={},
  expanded,
  tableDepth,
  height,
  actionPresetClass,
}) => {
  const classes = useStyle();
  
  const isSection = useMemo(() => (
    tableDepth === BreakdownTableDepths.SECTION
  ), [tableDepth]);

  return (
    <Grid
      item
      container
      role="row"
      wrap="nowrap"
      className={classnames(
        tableDepth >= 0 && `d${tableDepth}`,
        classes.row,
        expanded && classes.rowSelected,
        isLastGroupRow && "bottom",
        isFirstGroupRow && "top",
        expanded && !isSection && `preset-active-${tableDepth}`,
        !expanded && !isSection && "preset-row",
        isSection && "preset-sectionRow",
      )}
      style={style}
      aria-selected={expanded}
    >
      <DragHandleCell displayHandle={false} presetClass={actionPresetClass} />
      <PlaceholderCell fullWidth height={height} />
      {/*<VisibilityCell displayToggle={false} presetClass={actionPresetClass} />*/}
    </Grid>
  );
});

PlaceholderRow.propTypes = {
  isLastGroupRow: bool,
  isFirstGroupRow: bool,
  style: object,
  tableDepth: number,
  height: number,
  expanded: bool,
  actionPresetClass: string,
};
